export default __webpack_public_path__ + "static/media/Danilo Lima.58ff5574.png";